import { Injectable } from '@angular/core';
import { PaymentMethodName } from '../../enums/payment/payment-method-name';
import { DialogTableDataRow } from '../../interfaces/dialog-table-data-row';
import { TransactionData } from '../../interfaces/transaction/transaction-data';
import { AmountCurrencyDisplayPipe } from '../../pipes/amount-currency-display.pipe';

@Injectable({
  providedIn: 'root'
})
export class TransactionDetailsToTableDataMapper {

  constructor(private amountCurrencyPipe: AmountCurrencyDisplayPipe) { }

  public map(transactionData: TransactionData): DialogTableDataRow[] {
    let dialogTableDataRows: DialogTableDataRow[] = [
      {
        titleStyleClass: 'font-bold',
        i18nTitleKey: 'PAYMENTMETHOD',
        valueType: 'ICONANDTEXT',
        i18nValueKey: transactionData.paymentMethod,
        valueIcon: transactionData.icon,
        valueCustomIcon: transactionData.customIcon,
      },
      {
        titleStyleClass: 'font-bold',
        i18nTitleKey: 'TRANSACTIONTYPE',
        i18nValueKey: transactionData.type,
        // valueType:  'POSTPROCESSING',
        // flags: [true, true],
        valueType: transactionData?.capturePossible || transactionData.voidPossible ? 'POSTPROCESSING' : null,
        flags: [transactionData?.capturePossible, transactionData?.voidPossible],
      },
      {
        titleStyleClass: 'font-bold',
        i18nTitleKey: 'STATUS',
        valueType: 'STATE',
        value: transactionData.status,
      },
    ];
    if (transactionData.status === 'canceled') {
      dialogTableDataRows.push(
        {
          titleStyleClass: 'font-bold',
          i18nTitleKey: 'STATUSCODE',
          value: transactionData?.statusInfo + ' (' + transactionData?.statusCode +')',
        }
      )
    }
    dialogTableDataRows.push(
      {
        titleStyleClass: 'font-bold',
        i18nTitleKey: 'AMOUNT',
        value: this.amountCurrencyPipe.transform(transactionData.amount, transactionData.currency, 100),
      },
      {
        titleStyleClass: 'font-bold',
        i18nTitleKey: 'PURPOSE',
        value: transactionData?.purpose,
      },
      {
        titleStyleClass: 'font-bold',
        i18nTitleKey: 'DATE',
        value: transactionData.date,
        valueFormatPipe: 'FULLDATETIME',
      },
      {
        titleStyleClass: 'font-bold',
        i18nTitleKey: 'REFERENCE',
        value: transactionData?.reference,
      },
      {
        titleStyleClass: 'font-bold',
        title: 'Backend-ID',
        value: transactionData?.backendId,
      },
      {
        titleStyleClass: 'font-bold',
        i18nTitleKey: 'TRANSACTIONID',
        value: transactionData?.merchantTxId,
      },
      {
        titleStyleClass: 'font-bold',
        i18nTitleKey: 'BILLINGCODE',
        value: transactionData?.billingCode,
      },
    );
    if (transactionData.paymentMethod === PaymentMethodName.SEPA  || transactionData.paymentMethod === PaymentMethodName.SEPA_BLACKLIST) {
      dialogTableDataRows.push(
        {
          titleStyleClass: 'font-bold',
          i18nTitleKey: 'MANDATEREFERENCE',
          value: transactionData?.mandateReference ?? '',
        }
      );
    }
    if (transactionData.paymentMethod === PaymentMethodName.PAYPAL) {
      dialogTableDataRows.push(
        {
          titleStyleClass: 'font-bold',
          i18nTitleKey: 'PAYPALREFERENCENUMBER',
          value: transactionData?.payPalReferenceNumber ?? '',
        }
      );
    }
    if (transactionData.paymentMethod === PaymentMethodName.APPLEPAY) {
      dialogTableDataRows.push(
        /*
        {
          titleStyleClass: 'font-bold',
          i18nTitleKey: 'APPLEPAYREFERENCENUMBER',
          value: transactionData?.applePayReferenceNumber ?? '',
        },
         */
        {
          titleStyleClass: 'font-bold',
          i18nTitleKey: 'BASKETID',
          value: transactionData?.basketId ?? '',
        }
      );
    }
    if (transactionData.paymentMethod === PaymentMethodName.GOOGLEPAY) {
      dialogTableDataRows.push(
        /*
        {
          titleStyleClass: 'font-bold',
          i18nTitleKey: 'GOOGLEPAYREFERENCENUMBER',
          value: transactionData?.googlePayReferenceNumber ?? '',
        },
         */
        {
          titleStyleClass: 'font-bold',
          i18nTitleKey: 'BASKETID',
          value: transactionData?.basketId ?? '',
        }
      );
    }
    return dialogTableDataRows;
  }
}
